/**
 * Unit Data Class
 * 
 * Defines unit statistics and properties.
 * Ported from UnitData.as
 */

export class UnitData {
    constructor(
        icon,
        name,
        attackType,
        attackValue,
        foodUsage,
        space,
        productionSpeed,
        defInfantry,
        defCalvary,
        defMagic,
        defArtillery,
        wood,
        stone,
        iron,
        gold
    ) {
        this.icon = icon;
        this.name = name;
        this.attackType = attackType;
        this.attackValue = attackValue;
        this.foodUsage = foodUsage;
        this.space = space;
        this.productionSpeed = productionSpeed;
        this.defInfantry = defInfantry;
        this.defCalvary = defCalvary;
        this.defMagic = defMagic;
        this.defArtillery = defArtillery;
        this.wood = wood;
        this.stone = stone;
        this.iron = iron;
        this.gold = gold;
    }
    
    /**
     * Get build rate based on building type
     * This will be set dynamically based on city buildings
     */
    getBuildRate(gameEngine) {
        switch (this.name) {
            case "Watchman":
                return gameEngine.guard_rate || 0;
            case "Fianna":
            case "Archer":
            case "Hoplite":
                return gameEngine.training_ground_rate || 0;
            case "Scout":
            case "Hippotoxotai":
            case "Cataphract":
                return gameEngine.stable_rate || 0;
            case "Seer":
            case "Shaman":
                return gameEngine.moonglow_rate || 0;
            case "Cleric":
            case "Champion":
            case "Commander":
                return gameEngine.temple_rate || 0;
            case "Battering Ram":
            case "Ballista":
            case "Trebuchet":
                return gameEngine.workshop_rate || 0;
            case "Drakkar":
            case "Dromon":
            case "Carrack":
                return gameEngine.shipyard_rate || 0;
            default:
                return 0;
        }
    }
}

/**
 * All unit definitions
 * Ported from louo.as units array
 */
export const UNITS = [
    new UnitData('icon_units_cityguard', "Watchman", "None", 10, 2, 0, 50, 10, 10, 10, 10, 100, 0, 0, 0),
    new UnitData('icon_units_berserker', "Fianna", "Infantry", 50, 6, 1, 200, 15, 12, 10, 15, 0, 0, 150, 0),
    new UnitData('icon_units_ranger', "Archer", "Infantry", 30, 3, 1, 250, 40, 10, 25, 15, 160, 0, 0, 0),
    new UnitData('icon_units_guardian', "Hoplite", "Infantry", 10, 3, 1, 300, 30, 50, 20, 15, 0, 0, 120, 60),
    new UnitData('icon_units_scout', "Scout", "Calvary", 10, 5, 2, 300, 10, 10, 10, 10, 0, 0, 40, 120),
    new UnitData('icon_units_crossbow', "Hippotoxotai", "Calvary", 40, 10, 2, 600, 40, 90, 30, 40, 150, 0, 0, 200),
    new UnitData('icon_units_knight', "Cataphract", "Calvary", 90, 25, 2, 500, 40, 30, 20, 40, 0, 0, 250, 100),
    new UnitData('icon_units_mage', "Seer", "Magic", 70, 5, 1, 600, 15, 10, 30, 15, 0, 0, 50, 150),
    new UnitData('icon_units_warlock', "Shaman", "Magic", 120, 20, 2, 1300, 30, 20, 50, 40, 0, 0, 100, 350),
    new UnitData('icon_units_templar', "Cleric", "Infantry", 25, 3, 1, 350, 20, 30, 50, 15, 0, 0, 90, 100),
    new UnitData('icon_units_paladin', "Champion", "Calvary", 60, 15, 2, 700, 50, 20, 90, 40, 0, 0, 200, 160),
    new UnitData('icon_units_baron', "Commander", "Infantry", 10, 100, 1, 60000, 100, 50, 20, 10, 0, 0, 50000, 100000),
    new UnitData('icon_units_ram', "Battering Ram", "Artillery", 50, 50, 10, 2500, 20, 20, 20, 50, 500, 0, 300, 0),
    new UnitData('icon_units_ballista', "Ballista", "Artillery", 50, 25, 10, 3500, 200, 100, 200, 400, 400, 0, 600, 0),
    new UnitData('icon_units_catapult', "Trebuchet", "Artillery", 150, 50, 10, 4000, 100, 100, 200, 50, 300, 600, 200, 0),
    new UnitData('icon_units_sloop', "Drakkar", "Artillery", 1200, 300, 100, 25000, 4500, 4500, 2000, 6000, 6000, 0, 4000, 2000),
    new UnitData('icon_units_frigate', "Dromon", "Artillery", 3000, 500, 100, 40000, 4000, 4000, 2000, 2000, 15000, 0, 5000, 5000),
    new UnitData('icon_units_wargalleon', "Carrack", "Artillery", 12000, 2500, 400, 80000, 5000, 5000, 2500, 6000, 30000, 0, 10000, 20000)
];

